import { useEffect, useState } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, CircularProgress, Grid, Typography, LinearProgress } from '@mui/material';
import { useField } from '@unform/core';
import { UsuariosServiceAPI } from '../../../shared/services/api/usuario/UsuariosService';
import { useAuth } from '../../../shared/contexts';

interface IRole {
  id: number;
  description: string;
}

interface IRoleCheckboxProps {
  isExternalLoading?: boolean
}

export const RoleCheckbox: React.FC<IRoleCheckboxProps> = ({ isExternalLoading = false }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('roles');
  const { getUser } = useAuth();

  const [roles, setRoles] = useState<IRole[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<number[]>(defaultValue || []);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedRoles,
      setValue: (_, newSelectedRoles) => {
        setSelectedRoles(newSelectedRoles || []);
      },
    });
  }, [registerField, fieldName, selectedRoles]);
  

  useEffect(() => {
    setIsLoading(true);

    UsuariosServiceAPI.getRoles(getUser())
      .then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {
          console.error(result.message);
        } else {
          setRoles(result.data); // Certifique-se de que result.data é um array de IRole
        }
      });
  }, [getUser]);

  const handleRoleChange = (roleId: number) => {
    clearError();
    setSelectedRoles((prevSelected) =>
      prevSelected.includes(roleId)
        ? prevSelected.filter((id) => id !== roleId)
        : [...prevSelected, roleId]
    );
  };

  return (
    <FormControl component="fieldset" error={!!error} disabled={isExternalLoading || isLoading}>
      <Typography variant="h6" gutterBottom align="center">
        Permissões
      </Typography>

      {isLoading && (
        <Grid item>
          <LinearProgress variant='indeterminate' />
        </Grid>
      )}


      <Grid container spacing={2} justifyContent="start" alignItems="start">
        {roles.map((role) => (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={role.id}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedRoles.includes(role.id)}
                  onChange={() => handleRoleChange(role.id)}
                />
              }
              label={role.description}
              style={{ display: 'block', textAlign: 'left', marginLeft: 10 }}
            />
          </Grid>
        ))}
      </Grid>

      {!!error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
    </FormControl>
  );
};
